import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
  List,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import BusinessItem from '../../components/BusinessItem';
import styles from './styles.module.css';
import {KeyboardDatePicker} from '@material-ui/pickers';
import api from '../../core/api';
import ButtonExport from './buttonExport';

const style = {
  flexEnd: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  datePicker: {
    width: 'fit-content',
    border: 'solid 1px #d3d3d3',
    borderRadius: '4px',
  },
};

const BusinessPage = ({history}) => {
  const [allBusiness, setAllBusiness] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [isLoading, setLoading] = useState(true);
  const [filterValue, setFilterValue] = useState('');
  const [customerSize, setCustomerSize] = useState('');
  const [clientType, setClientType] = useState('');
  const [clientStatus, setClientStatus] = useState('');
  const [contractDate, setContractDate] = useState(null);
  const [contractValidityDate, setContractValidityDate] = useState(null);
  const [numericFilter, setNumericFilter] = useState(null);
  const [error, setError] = useState(false);
  

  const handleFilterChange = event => {
    setFilterValue(event.target.value);
  };

  const handleCustomerSizeSelectChange = event => {
    setCustomerSize(event.target.value);
  };

  const handleClientTypeSelectChange = event => {
    setClientType(event.target.value);
  };

  const handleClientStatusSelectChange = event => {
    setClientStatus(event.target.value);
  };

  const handleNumericFilterChange = event => {
    setNumericFilter(event.target.value);
  };

 async function fetchBusiness() {
   
     
    setLoading(true);
    const filters = {
      filterValue,
      customerSize,
      clientType,
      clientStatus,
      contractDate,
      contractValidityDate,
      numericFilter,
    };

    try {
      const {data} = await api.get('business', {
        params: { filters },
      })
      setAllBusiness(data);
      setError(false);
    } catch (err) {
      setError(true);
    } finally {
      setFirstLoading(false);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchBusiness();
  }, [
    filterValue,
    customerSize,
    clientType,
    clientStatus,
    contractDate,
    contractValidityDate,
    numericFilter,
  ]);

  if (error) {
    return (
      <div>
        <p style={{textAlign: 'center'}}>Ocorreu um erro ao obter os dados.</p>
        <p style={{textAlign: 'center'}}>
          <a href="javascript:void(0)" onClick={fetchBusiness}>
            Tentar novamente
          </a>
        </p>
      </div>
    );
  }

  return (
    <Dashboard>
      {firstLoading ? (
        <div className="flex-col center-a center-b" style={{height: '50vh'}}>
          <span style={{paddingTop: '10em'}}>
            <CircularProgress size={100} />
            <p> Carregando... </p>
          </span>
        </div>
      ) : (
        <div style={{overflow: 'hidden'}}>
          <div className={styles['filter-bar']}>
            <TextField
              style={{width: '100%'}}
              variant="outlined"
              label="Buscar empresas (por Código do cliente, Razão social/Nome completo, Nome fantasia, Ramo de atividade, Cidade ou Estado"
              value={filterValue}
              onChange={handleFilterChange}
            />
            <FormControl>
              <InputLabel
                id="subscription-type-label"
                style={{paddingLeft: '15px'}}>
                Porte do Cliente
              </InputLabel>
              <Select
                labelId="subscription-type-label"
                className={styles.select}
                variant="outlined"
                placeholder=""
                value={customerSize}
                onChange={handleCustomerSizeSelectChange}>
                {['Todos', 'Micro', 'Pequeno', 'Médio', 'Grande'].map(type => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel
                id="subscription-type-label"
                style={{paddingLeft: '15px'}}>
                Tipo de Cliente
              </InputLabel>
              <Select
                labelId="subscription-type-label"
                className={styles.select}
                variant="outlined"
                placeholder=""
                value={clientType}
                onChange={handleClientTypeSelectChange}>
                {[
                  'Todos',
                  'Corporativo',
                  'Indústria',
                  'Comércio',
                  'ONG/OCIP',
                  'Associação',
                ].map(type => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel
                id="subscription-type-label"
                style={{paddingLeft: '15px'}}>
                Status do Cliente
              </InputLabel>
              <Select
                labelId="subscription-type-label"
                className={styles.select}
                variant="outlined"
                placeholder=""
                value={clientStatus}
                onChange={handleClientStatusSelectChange}>
                {[
                  'Todos',
                  'Pesquisa',
                  'Em prospecção',
                  'Não houve interesse',
                  'Proposta enviada',
                  'Em negociação',
                  'Proposta recusada',
                  'Contrato ativo',
                  'Em suspenso',
                  'Inativo',
                ].map(type => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <div style={style.datePicker}>
                <KeyboardDatePicker
                  placeholder="Data de contrato"
                  value={contractDate}
                  onChange={dateForm => {
                    setContractDate(new Date(dateForm));
                  }}
                  format="DD/MM/YYYY"
                />
              </div>
            </FormControl>
            <FormControl>
              <div style={style.datePicker}>
                <KeyboardDatePicker
                  placeholder="Vigência do contrato"
                  value={contractValidityDate}
                  onChange={dateForm => {
                    setContractValidityDate(dateForm);
                  }}
                  format="DD/MM/YYYY"
                />
              </div>
            </FormControl>

            <TextField
              type="number"
              variant="outlined"
              label="Número de usuários"
              value={numericFilter}
              onChange={handleNumericFilterChange}
            />
          </div>
          <Grid container justify="flex-end">
            <Button
              sx={{borderRadius: 10}}
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => history.push(`${window.location.pathname}/add`)}>
              Nova Empresa
            </Button>

            <ButtonExport
              filterValue={filterValue}
              customerSize={customerSize}
              clientType={clientType}
              clientStatus={clientStatus}
              contractDate={contractDate}
              contractValidityDate={contractValidityDate}
              numericFilter={numericFilter}
            />
          </Grid>
          {isLoading ? (
            <div
              className="flex-col center-a center-b"
              style={{height: '50vh'}}>
              <span style={{paddingTop: '10em'}}>
                <CircularProgress size={100} />
                <p> Carregando... </p>
              </span>
            </div>
          ) : allBusiness.length <= 0 ? (
            <div
              style={{
                display: 'flex',
                marginBottom: '10px',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <p
                style={{
                  fontSize: '1.1876rem',
                  color: '#b1a4aa',
                }}>
                Nenhuma empresa encontrada.
              </p>
            </div>
          ) : (
            <>
              <div style={{marginBottom: 20}} />
              <List>
                {allBusiness.map(business => (
                  <BusinessItem history={history} business={business} />
                ))}
              </List>
            </>
          )}
        </div>
      )}
    </Dashboard>
  );
};

export default BusinessPage;
